import { message } from "antd";
import "./CenteredMessage.css";

let blurOverlay = null;
let hideTimer = null;

const showBlurOverlay = () => {
  // clear any pending hide
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }

  if (!blurOverlay) {
    blurOverlay = document.createElement("div");
    blurOverlay.className = "blur-background";
    document.body.appendChild(blurOverlay);
  }
};

const hideBlurOverlay = () => {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }

  if (blurOverlay) {
    blurOverlay.remove(); // safer than removeChild
    blurOverlay = null;
  }
};

// keep duration in one place
const DURATION = 1;

message.config({
  maxCount: 1,
  duration: DURATION,
  top: "50%",
  className: "centered-message-container",
});

const fire = (type, text) => {
  // ✅ if an old message exists, remove it + remove overlay
  message.destroy();
  hideBlurOverlay();

  showBlurOverlay();

  // ✅ fallback: even if onClose doesn't run, overlay will hide
  hideTimer = setTimeout(() => {
    hideBlurOverlay();
  }, (DURATION + 0.2) * 1000);

  message[type]({
    content: text,
    duration: DURATION,
    onClose: hideBlurOverlay,
  });
};

const CenteredMessage = {
  success: (text) => fire("success", text),
  error: (text) => fire("error", text),
  info: (text) => fire("info", text),
  warning: (text) => fire("warning", text),
};

export default CenteredMessage;